const initialState = {
    items: [],
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'DIVISION_LIST_LOADING':
            return {
                ...state,
                loading: true
            };
        case 'DIVISION_LIST_SUCCESS':
            return {
                ...state,
                items: action.payload.data,
                loading: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/division.js